import { useCallback, Fragment } from 'react';
import { AutocompleteMulti, getRenderTagsForAutocompleteMulti } from '../AutocompleteInput';
import { SelectOption } from '../Select';
import { AutocompleteRenderOptionState, Checkbox } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type SearchableChecklistProps = {
  name: string;
  options: SelectOption[];
  placeholder: string;
  color: 'primary' | 'secondary' | undefined;
  label: string;
};

export const SearchableChecklist: React.VFC<SearchableChecklistProps> = ({ name, options, placeholder, label }) => {
  const { classes } = useStyles();


  const renderOption = useCallback((option: SelectOption & {id: string}, state: AutocompleteRenderOptionState) => {
    return (
      <Fragment>
        <Checkbox color="secondary" checked={state.selected} />
        {option.label}
      </Fragment>
    );
  }, []);

  return (
    <AutocompleteMulti
      label={label}
      name={name}
      classes={{
        option: classes.option,
      }}
      color="secondary"
      placeholder={placeholder}
      disableCloseOnSelect={true}
      getOptionLabel={(opt) => opt?.label ?? ''}
      options={options.map(o => ({ ...o, id: o.value }))}
      renderTags={getRenderTagsForAutocompleteMulti((opt) => opt?.label ?? '')}
      renderOption={renderOption}
      getOptionDisabled={() => false}
    />
  );
};

const useStyles = makeStyles({ name: 'SearchableChecklist' })(theme => ({
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: theme.palette.secondary.background
    }
  },
}));
